/* eslint-disable no-use-before-define */
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import api from '@baseUtils/Api';
import Container from '@material-ui/core/Container';
import TextTelefone from '../../utils/InputTextTelefone'

import './styles.css';

const Identificacao = (props) => {
  const [data, setData] = useState(props.data);
  const latestData = useRef(data);
  const [bairros, setBairros] = useState([]);
  const [cnaes, setCnaes] = useState([]);
  const [isValid, setIsValid] = useState(!props.data.atividades);
  useEffect(()=>{

  },[data])

  function formatarCampo(campoTexto) {
    if (campoTexto.value.length <= 11) {
      campoTexto.value = mascaraCpf(campoTexto.value);
    } else {
      campoTexto.value = mascaraCnpj(campoTexto.value);
    }
  }
  function retirarFormatacao(campoTexto) {
    campoTexto.value = campoTexto.value.replace(/(.|\/|-)/g, "") ;
  }
  function mascaraCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"$1.$2.$3-$4");
  }
  function mascaraCnpj(valor) {
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"$1.$2.$3/$4-$5");
  }

  function handleCpfnpjBLur(event) {
    formatarCampo(event.target);
  }

  const handleInputChange = ({target: {name, value}}) => {
    setData({...data, [name]: value});
  };

  const handleSelectChange = ((_, values) => {
    setData({...data, bairro: values});
  });

  const handleSelectChangeAtividades = ((name, values) => {
    setIsValid(!values.length);
    setData({...data, atividades: values});
  });

  const handleDataChanged = () => {
    const { dispatch } = props;
    dispatch({
      type: 'ADD_TO_FORM',
      data: {
        Identificacao: latestData.current
      }
    });
  }

  useEffect(() => {
    latestData.current = data;
  }, [data]);

  useEffect(() => {
    api.get('/json/bairros.json')
      .then(({data}) => setBairros(data))
    api.get('/json/cnaes.json')
      .then(({data}) => setCnaes(data))
    return () => handleDataChanged()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container maxWidth="lg" className="container">
      <h1 className="mobile-title" style={{display: 'none'}}>1. Identificação</h1>
      <div className="form-group">
        <TextField
          className="input-mobile"
          label = "Razão social"
          name = "razaoSocial"
          inputProps={{ minLength: 10 }}
          autoFocus
          required
          defaultValue = {data.razaoSocial}
          onChange = {handleInputChange}
          variant="outlined"
        />
        <TextField
          label="Nome fantasia"
          name="nomeFantasia"
          inputProps={{ minLength: 10 }}
          required
          defaultValue = {data.nomeFantasia}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>
      <div className="form-group">
        <TextField
          type="text"
          name="cpfCnpj"
          label="CPF/CNPJ"
          required
          onChange={handleInputChange}
          onBlur={handleCpfnpjBLur}
          onFocus={(e) =>  retirarFormatacao(e.target)}
          variant="outlined"
          defaultValue ={data.cpfCnpj}
        />
        <TextTelefone
          className="telefone"
          label="Inscrição Municipal"
          type="number"
          placeholder=""
          name="inscricaoMunicipal"
          defaultValue = {data.inscricaoMunicipal}
          onChange={handleInputChange}
          variant="outlined"
          // mask="(99) 99999-9999"
        />
        <TextTelefone
            minLength={10}
            required
            type="tel"
            name="telefone"
            label="Telefone"
            placeholder=""
            onChange={handleInputChange}
            defaultValue = {data.telefone}
            mask="(99) 99999-9999"
          />
      </div>
      <div className="form-group">
        <TextField
          className="text-field"
          label="Responsável"
          inputProps={{ minLength: 5 }}
          name="responsavel"
          required
          placeholder="Ex.: Marcelo Dias Lopes"
          defaultValue = {data.responsavel}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
          className="text-field"
          label="Cargo"
          name="cargo"
          inputProps={{ minLength: 5 }}
          required
          defaultValue = {data.cargo}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextTelefone
            required
            type="tel"
            placeholder=""
            name="whatsapp"
            label="WhatsApp"
            onChange={handleInputChange}
            defaultValue = {data.whatsapp}
            mask="(99) 99999-9999"
        />
      </div>
      <div className="form-group">
        <div className="autocomplete">
          <Autocomplete
            multiple={true}
            options={[...cnaes]}
            filterSelectedOptions
            getOptionSelected={(option, value) => option.codigo === value.codigo}
            getOptionLabel={option => `${option.codigo} - ${option.descricao}`}
            defaultValue = {props.data.atividades}
            onChange = {(...values) => handleSelectChangeAtividades(...values)}
            renderInput={(params) => (
              <TextField
                {...params}
                required={isValid}
                variant="outlined"
                label="Ramo / Atividades"
                placeholder="Clique e selecione as atividades digitando o número ou o nome"
              />
            )}
          />
        </div>
      </div>
      <div className="form-group">
        <TextField
        className="endereco"
          label="Endereço"
          name="endereco"
          required
          defaultValue = {data.endereco}
          onChange={handleInputChange}
          variant="outlined"
        />
        <Autocomplete
          options = {bairros}
          getOptionLabel = {(option) => option.descricao }
          onChange = {handleSelectChange}
          value = {data.bairro }
          getOptionSelected = {(option, value) => [option.codigo === value.codigo]}
          renderInput = {(params) => <TextField
            variant="outlined"
            required={props.data.bairro !== '' ? true : false  }
          className="autoCompleteBairro" {...params} label="Selecione o seu Bairro" />}
        />
      </div>
    </Container>
  );
}

export default connect(state => ({
  data: state.form.Identificacao,
}))(Identificacao);
